import React from 'react'

function Showcase() {
  return (
    <div>Showcase</div>
  )
}

export default Showcase